export default "__VITE_ASSET__DEjVTS71__"